import { Toggle as TogglePrimitive } from '@base-ui/react/toggle';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'cn';

const toggleVariants = cva(
  'tw:group/toggle tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:rounded-lg tw:font-medium tw:whitespace-nowrap tw:transition-[color,box-shadow,background-color,border-color] tw:outline-none tw:focus-visible:ring-[3px] tw:focus-visible:ring-ring/50 tw:disabled:pointer-events-none tw:disabled:bg-muted tw:disabled:text-muted-foreground tw:disabled:shadow-none tw:aria-pressed:bg-primary tw:aria-pressed:text-primary-foreground tw:aria-pressed:shadow-xs tw:disabled:aria-pressed:bg-muted tw:disabled:aria-pressed:text-muted-foreground tw:disabled:aria-pressed:shadow-none tw:aria-invalid:border-destructive tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:[&_svg]:pointer-events-none tw:[&_svg]:shrink-0 tw:[&_svg:not([class*=size-])]:size-4',
  {
    variants: {
      variant: {
        default:
          'tw:bg-transparent tw:text-foreground tw:hover:bg-primary tw:hover:text-primary-foreground tw:hover:shadow-xs',
        outline:
          'tw:border tw:border-border tw:bg-transparent tw:text-foreground tw:not-aria-pressed:hover:border-ring tw:aria-pressed:border-transparent tw:disabled:bg-transparent tw:disabled:border-transparent',
      },
      size: {
        default:
          'tw:h-9 tw:min-w-9 tw:px-2.5 tw:text-sm tw:has-data-[icon=inline-end]:pr-2 tw:has-data-[icon=inline-start]:pl-2',
        sm: 'tw:h-8 tw:min-w-8 tw:px-2.5 tw:text-sm tw:has-data-[icon=inline-end]:pr-1.5 tw:has-data-[icon=inline-start]:pl-1.5',
        lg: 'tw:h-10 tw:min-w-10 tw:px-2.5 tw:!text-base tw:has-data-[icon=inline-end]:pr-2 tw:has-data-[icon=inline-start]:pl-2 tw:[&_svg:not([class*=size-])]:size-5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

function Toggle({
  className,
  variant = 'default',
  size = 'default',
  ...props
}: TogglePrimitive.Props & VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Toggle, toggleVariants };
